
import { mapGetters, mapActions } from "vuex";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "app-usuarios",
  mixins: [SistemaMixin],
  components: {},
  data() {
    return {
      tabIndex: 0,
      nome: "",
      password: "",
      confirmPassword: "",
    };
  },
  methods: {
    async salvarNovaSenha() {
      const submitButton = this.$refs["submit_nova_senha"];

      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      submitButton.setAttribute("disabled", "");

      const nome = this.nome.trim();
      const alterarSenha = this.password !== "" || this.confirmPassword !== "";

      if (!nome) {
        this.$toast.error("Informe o nome de apresentação.");
      } else if (
        alterarSenha &&
        (this.password === "" ||
          this.confirmPassword === "" ||
          this.password !== this.confirmPassword)
      ) {
        this.$toast.error(
          "Erro ao salvar a nova senha. Verifique se as duas senhas são iguais."
        );
      } else {
        const params = {
          id_usuario: this.currentUser.id_usuario,
          nome,
        };

        if (alterarSenha) {
          params.password = this.password;
        }

        try {
          const { data } = await this.$http.post(
            "/usuario/update-perfil",
            params
          );

          if (data && data.status === false) {
            this.$toast.error(data.msg || "Erro ao atualizar o perfil.");
          } else {
            this.password = "";
            this.confirmPassword = "";
            this.$toast.success("Perfil atualizado com sucesso!");
            window.location.reload();
          }
        } catch (error) {
          this.$toast.error(this.getErrorMessage(error));
        }
      }
      submitButton.classList.remove(
        "spinner",
        "spinner-light",
        "spinner-right"
      );
      submitButton.removeAttribute("disabled", "");
    },
    getErrorMessage(error) {
      return (
        error?.response?.data?.msg ||
        error?.response?.data?.message ||
        error?.message ||
        "Erro ao atualizar o perfil."
      );
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked", "currentUser"]),
    ...mapActions(["setLoading"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.nome = this.currentUser.nome || "";
  },
};
